$(function () {
    $('.image-gallery-slider').carousel('pause');

    // Control buttons
    $('.image-gallery-slider .next-slide').click(function () {
        $(this).closest('.image-gallery-slider.carousel').carousel('next');
        return false;
    });
    $('.image-gallery-slider .prev-slide').click(function () {
        $(this).closest('.image-gallery-slider.carousel').carousel('prev');
        return false;
    });
});